import { createFileRoute } from '@tanstack/react-router';

import { TemplateFillPage } from '@pages/templates/template-fill-page.js';
import { IamService } from '@units/iam';

/**
 * `/templates/$templateId_/fill` — wiring only.
 *
 * Гард — `template:generate_document`: право заполнить и собрать документ у формы, отличное от
 * права её видеть. `whenDenied: 'forbidden'` — кнопка «Заполнить» на карточке формы уже прячется
 * без этого права (`TemplateCardActions`), и прямой заход по ссылке без права называет то, чего
 * не хватает, а не притворяется несуществующим адресом.
 *
 * **Не дочерний маршрут карточки, хотя лежит в её каталоге.** `$templateId_` (с завершающим `_`)
 * — приём TanStack Router «non-nested route»: путь остаётся `/templates/$templateId_/fill`, но
 * родителем в дереве становится `_authenticated`, а не `/templates/$templateId`. Так и было
 * задумано: `TemplatePage` не рисует `<Outlet />` (в приложении он есть только у двух настоящих
 * оболочек — `root-layout` и `authenticated-layout`, `rules/frontend-fsd.mdc`), а этот экран несёт
 * свой собственный `PageHeader` — вложение удвоило бы шапку, а не дало вкладку внутри карточки.
 * Настоящая же (физическая) вложенность молча собирала этот маршрут под карточку и оставляла его
 * недостижимым: адрес совпадал, а отрисовать было нечего — карточка не знала, что показывать
 * дальше своей истории версий.
 */
export const Route = createFileRoute('/_authenticated/templates/$templateId_/fill')({
  beforeLoad: IamService.IamGuards.requirePermission({
    permission: 'template:generate_document',
    whenDenied: 'forbidden',
  }),
  component: TemplateFillPage,
  staticData: { crumbKey: 'templates.fill.title' },
});
